import { Verify } from '@/components/templates/Verify/templates/Verify'

export default Verify
